import type { HandleMentionsChangedProps } from './hooks/useMentionsNotifications';

export const handleMentionsChanged = ({
	mentionChanges,
	deletedMentions,
	addedMentions,
	setDeletedMentions,
	setAddedMentions,
	userId,
}: HandleMentionsChangedProps) => {
	// Process added mentions first
	const addedMentionsExcludingCurrentUser = mentionChanges.filter(
		(mentionChange) => mentionChange.id !== userId && mentionChange.type === 'added',
	);

	const currentAndNewAddedMentions = [...addedMentions, ...addedMentionsExcludingCurrentUser];

	if (addedMentionsExcludingCurrentUser.length > 0) {
		void setAddedMentions(currentAndNewAddedMentions);
	}

	const currentAndNewAddedMentionsLocalIds = new Set(
		currentAndNewAddedMentions.map((mention) => mention.localId),
	);

	// Process deleted mentions next, but only if they exist in the added mentions
	const validDeletedMentions = mentionChanges.filter(
		(mentionChange) =>
			mentionChange.id !== userId &&
			mentionChange.type === 'deleted' &&
			currentAndNewAddedMentionsLocalIds.has(mentionChange.localId),
	);

	if (validDeletedMentions.length > 0) {
		void setDeletedMentions([...deletedMentions, ...validDeletedMentions]);
	}
};
